interface Labels {
  main?: string[];
  getMainKeys?: (foo?: any) => void;
  sub?: string[];
  getSubKeys?: (foo?: any) => void;
}

export interface SelectSearchOptions {
  labelText?: string;
  placeholder?: string;
  optionKey: Labels;
  valueKey: string;
  removeSeparator?: boolean;
}

export interface CustomComponent {
  [key: string]: any;
}
